// eslint-disable-next-line no-unused-vars
import BaseBreadCrumbs from '../../../common/BaseBreadCrumbs'

export const types = {
  ADD_BRIEF_CONTENT_NAME: 'breadcrumb/ADD_BRIEF_CONTENT_NAME',
  RESET_BRIEF_CONTENT_NAME: 'breadcrumb/RESET_BRIEF_CONTENT_NAME'
}
const state = {
  briefName: ''
}

const mutations = {
  [ types.ADD_BRIEF_CONTENT_NAME ]: function (state, name) {
    state.briefName = name || ''
  },
  [ types.RESET_BRIEF_CONTENT_NAME ]: function (state) {
    state.briefName = ''
  }
}

const actions = {
  /**
   * set brief content name as last past segment in bread crumb
   */
  setBriefContentName: function ({ commit }, { name }) {
    commit(types.ADD_BRIEF_CONTENT_NAME, name)
  },
  resetBriefContentName: function ({ commit }) {
    commit(types.RESET_BRIEF_CONTENT_NAME)
  }
}

/**
 * Store manage bread crumb's {@link BaseBreadCrumbs}
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
